import SettingsMyCompanyEditSite from './MyCompanyEditSite';
import { createMyCompanyEditSiteHandle } from './handle';

export default {
  Component: SettingsMyCompanyEditSite,
  createHandle: createMyCompanyEditSiteHandle
};
